import React from 'react'
import classes from './NewsContent.module.css'
import { NewsCard } from '../NewsCard'
import { CategoriesLayout } from '../../layouts/CategoriesLayout/CategoriesLayout'

export const NewsContent = ({ heading, data, isHeading, dataLength }) => (
  <section>
    <CategoriesLayout isNews heading={heading}>
      <div
        className={isHeading ? classes.content_heading : classes.content_news}
      >
        {dataLength ? (
          <>
            {data.map(({ results }) =>
              results.map((info, index) => (
                <NewsCard isHeading={isHeading} key={index} info={info} />
              ))
            )}
          </>
        ) : (
          <p>Тут еще нет новостей</p>
        )}
      </div>
    </CategoriesLayout>
  </section>
)
